module.exports = __webpack_public_path__ + "static/media/arrow.28ee4062.svg";